<template>
  <div class="swiper-container swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-bind:key="item.index" v-for="item in imgs" :id="'class'+(item.index+1)">
        <div class="container">
          <div class="item" @click="changeNav(item.index)">
            <img alt="xxx" :src="item.imgUrl" style="width: 100%;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "./js/swiper.min.js";
export default {
  props: ["changeNav"],
  name: "swiper",
  data() {
    return {
      imgs: [
        {
          index: 0,
          imgUrl: require("../../../assets/classroom/imgsMobile/001.png"),
        },
        {
          index: 1,
          imgUrl: require("../../../assets/classroom/imgsMobile/004.jpg"),
        },
        {
          index: 2,
          imgUrl: require("../../../assets/classroom/imgsMobile/005.jpg"),
        },
      ],
    };
  },
  methods: {
    initSwiper() {
      const swip = new Swiper(".swiper", {
        direction: "vertical",
        height: 600,
      });
    },
  },
  created() {},
  mounted() {
    this.initSwiper();
  },
};
</script>
<style scoped>
@import url("./css/swiper.min.css");

.swiper-container {
  position: relative;
  width: 100%;
  height: 600px;
}
.container {
  position: relative;
  width: 100%;
}
.container .item {
  width: 100%;
}

@media screen and (min-width: 1px) {
  .swiper-button-black {
    --swiper-navigation-size: 20px; /* 设置按钮大小 */
    color: rgba(255, 255, 255, 1);
    background: rgba(0, 0, 0, 0.7);
    border-radius: 2px;
    width: 15px;
    height: 30px;
    padding: 2px;
  }
}
@media screen and (min-width: 1px) and (max-width: 1300px) {
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
}
</style>
